// extracted by mini-css-extract-plugin
module.exports = {"root":"simpleFaq_root__28GnU","inner":"simpleFaq_inner__3Olxw","items":"simpleFaq_items__3Ntd2"};